import { makeAutoObservable } from "mobx";

class PlayStore {
  play = "000";
  constructor() {
    makeAutoObservable(this);
  }
  setPlay = (boolean) => {
    this.play = boolean;
  };
}

export default PlayStore;
